import {ActionConst} from '../../actions/auth'

const initialState = {
  dataObject: {},
  token: undefined,
  isFetching: false,
  error:{}
}

export default function reducer (state = initialState, action) {
  switch (action.type) {
    case ActionConst.SET_DATA_OBJECT:
      return {...state, error:{}, dataObject: action.dataObject}
    case ActionConst.SET_TOKEN:
      return {...state, token: action.token}
    case ActionConst.SET_ERROR:
      return {...state, error: action.error}
    case ActionConst.IS_FETCHING:
      return {...state, isFetching: action.isFetching}
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/reducers/auth/index.js